import { render, staticRenderFns } from "./simpleAds.vue?vue&type=template&id=68521551&scoped=true"
import script from "./simpleAds.vue?vue&type=script&lang=js"
export * from "./simpleAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68521551",
  null
  
)

export default component.exports